module.exports = __webpack_public_path__ + "static/img/marketing-min.0c8fae00.png";